export const BREAKPOINTS = {
    ZERO: 0,
    S: 20,
    M: 48,
    L: 75,
    XL: 90,
};
//# sourceMappingURL=breakpoints.js.map